import React from 'react'
import {Stack, Typography} from '@mui/material'
import TextFieldNew from 'src/components-new/inputs/TextFieldNew'

export interface AccountStepValue {
  email: string
  code: string
}

interface AccountStepProps {
  value: AccountStepValue
  onChange: (value: AccountStepValue) => void
  activationCodeRequired: boolean
  errors: Record<string, string>
  disabled?: boolean
}

/**
 * Step 1/3 — new-style equivalent of
 * src/pages/selfRegistration/steps/FirstStep/FirstStep.tsx. The activation code field is
 * shown only when `firstLoginConfiguration.activationCodeRequired` is set, same as legacy.
 * Validation (email format, `checkEmail`/`checkRegistrationToken`) lives in the parent
 * container's `validateAccountStep`, matching the SecondaryTherapyDialogNew convention of
 * keeping step validation in the orchestrator rather than the leaf step component.
 */
export default function AccountStep({value, onChange, activationCodeRequired, errors, disabled}: AccountStepProps): JSX.Element {
  return (
    <Stack spacing={2.5}>
      <Typography variant="body2" color="text.secondary">
        {'Crea il tuo account per poter accedere ai servizi a te riservati'}
      </Typography>

      <TextFieldNew
        label="Email"
        type="email"
        value={value.email}
        onChange={(email) => onChange({...value, email})}
        autoComplete="email"
        autoFocus
        required
        fullWidth
        disabled={disabled}
        error={Boolean(errors.email)}
        helperText={errors.email}
      />

      {activationCodeRequired && (
        <TextFieldNew
          label="Codice di attivazione"
          value={value.code}
          onChange={(code) => onChange({...value, code})}
          required
          fullWidth
          disabled={disabled}
          error={Boolean(errors.code)}
          helperText={errors.code}
        />
      )}
    </Stack>
  )
}
